<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">請求管理</div>
      </md-card-header>

      <md-card-content>
        <a href="#" @click="backToList()">
          <md-button class="md-raised">
            <md-icon>arrow_back</md-icon>
            <span>戻る</span>
          </md-button>
        </a>
      </md-card-content>

      <md-card-content v-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <loading-spinner v-else-if="loadingSpinner"></loading-spinner>
      <div v-else class="md-layout">
        <div class="md-layout-item md-size-20 md-small-size-100"></div>
        <div class="md-layout-item md-size-60 md-small-size-100">
          <md-card-content>
            <md-table class="md-table-no-border">
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求月</md-table-cell>
                <md-table-cell v-if="billing.billing_month !== null">
                  {{datetimeFormat(billing.billing_month + '01', 'YYYY年M月')}}（{{datetimeFormat(billing.use_month,
                  'M月')}}ご利用分）
                </md-table-cell>
                <md-table-cell v-else></md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">伝票番号</md-table-cell>
                <md-table-cell>{{billing.no}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">法人名</md-table-cell>
                <md-table-cell>{{billing.corporation}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">支払情報の名称</md-table-cell>
                <md-table-cell>{{billing.payment_method ? billing.payment_method.label : null}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求額(税込)</md-table-cell>
                <md-table-cell v-if="billing.total_billed !== null">
                  {{numberFormat(billing.total_billed)}}円
                </md-table-cell>
                <md-table-cell v-else></md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">支払状況</md-table-cell>
                <md-table-cell>{{paymentStatusLabel(billing.status)}}</md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求書送付</md-table-cell>
                <md-table-cell>{{billing.payment_method ? getBillViaName(billing.payment_method.bill_via) : null}}
                </md-table-cell>
              </md-table-row>
              <md-table-row>
                <md-table-cell class="md-layout md-alignment-center-right">請求書/明細</md-table-cell>
                <md-table-cell>
                  <md-button :href="billing.pre_signed_url" target="_blank" class="md-raised"
                             v-if="billing.pre_signed_url">
                    <md-icon class="material-icons">
                      picture_as_pdf
                    </md-icon>
                    <span>ダウンロード</span>
                  </md-button>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </md-card-content>
        </div>
      </div>
    </md-card>
  </main>
</template>

<script>
  import FlashMessage                                   from '../../../components/FlashMessage';
  import CommonMixin                                    from "../../../mixins/commonMixin";
  import LoadingSpinner                                 from '../../../components/LoadingSpinner';
  import {apiClientWithUserToken as apiClient, apiList} from '../../../modules/apiClient';
  import Common                                         from '../../../modules/common';
  import {mapActions}                                   from 'vuex';

  export default {
    name      : "UserBillingDetail",
    mixins    : [CommonMixin],
    components: {
      FlashMessage,
      LoadingSpinner
    },
    props     : {
      id: String,
    },
    data      : () => ({
      billing: [],
    }),
    mounted   : function () {
      this.getBillingDetail();
    },
    methods   : {
      ...mapActions('billings', [
        'saveBack',
      ]),
      backToList() {
        this.saveBack(true);
        this.$router.replace({name: 'BackendUserBillings'}).then();
      },
      getBillingDetail() {
        this.loadingSpinner = true;
        const url           = apiList.jon.user_billings.detail.replace(':id', this.$props.id);
        apiClient.get(url)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (response.data.billing) {
              this.billing = response.data.billing;
              return;
            }
            this.errorMessages = [Common.messages.errorGet];
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.loadingSpinner = false;
          });
      },
    }
  }
</script>

<style lang="scss" scoped>
  tbody .md-table-row .md-table-cell,
  tbody .md-table-row .md-table-cell:last-child,
  tbody .md-table-row:last-child .md-table-cell {
    border: none;
  }
</style>
